import React from "react";
import { PinProps } from "./Pin.types";
import InfoWindow from "../info-window/InfoWindow";

const Pin = (props: PinProps) => (
    <div
        style={{
            backgroundColor: "white",
        }}
    >
        <span className="material-icons">
            place
        </span>
        {props.show && <InfoWindow place={props.place} />}
    </div>
);

export default Pin;
